import { useScene } from 'src/hooks/useScene';
import { IsoTileArea } from 'src/components/IsoTileArea/IsoTileArea';
import { getColorVariant } from 'src/utils';
import { useColor } from 'src/hooks/useColor';

type Props = ReturnType<typeof useScene>['rectangles'][0];

export const Rectangle = ({
  from,
  to,
  color: colorId,
  opacity = 0.3,
  borderWidth = 2,
  borderStyle = 'SOLID',
  borderColor,
  cornerRadius = 12,
  fill = true
}: Props) => {
  const fillColor = useColor(colorId);
  const borderColorValue = useColor(borderColor); 

  // Convert border style to stroke dash array
  const getStrokeDashArray = (style: string = 'SOLID'): string => {
    switch (style) {
      case 'DASHED':
        return '10,5';
      case 'DOTTED':
        return '2,3';
      case 'SOLID':
      default:
        return '0';
    }
  };

  // If borderColor is provided, use it; otherwise use darker variant of fill
  const strokeColor = borderColor
    ? borderColorValue.value
    : getColorVariant(fillColor.value, 'dark', { grade: 2 });

  return (
    <IsoTileArea
      from={from}
      to={to}
      fill={fill ? fillColor.value : 'transparent'}
      opacity={opacity}
      cornerRadius={cornerRadius}
      stroke={{
        color: strokeColor,
        width: borderWidth,
        dashArray: getStrokeDashArray(borderStyle)
      }}
    />
  );
};
